import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TranslateLoader, TranslateModule, TranslateService } from "@ngx-translate/core";
import { AngularFireModule } from 'angularfire2';
// import { AuthConfigService } from "./services/authconfig.service";
// import { Title } from '@angular/platform-browser';
// import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
// import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Ng2PicaModule, Ng2PicaService } from 'ng2-pica';
import { QuillModule } from 'ngx-quill';
import { DataScrollerModule } from "primeng/components/datascroller/datascroller";
import { AutoCompleteModule, ButtonModule, CalendarModule, ChartModule, CheckboxModule, ConfirmationService, DataListModule, DataTableModule, DialogModule, DropdownModule, EditorModule, GalleriaModule, GMapModule, InputTextareaModule, InputTextModule, LightboxModule, MenuModule, OverlayPanelModule, PanelModule, PickListModule, ProgressSpinnerModule, SidebarModule, SliderModule, TabMenuModule, TabViewModule, TooltipModule, TreeTableModule } from "primeng/primeng";
import { environment } from "../environments/environment";
import { AnalyticsModule } from './analytics/analytics.module';
import { ActionDispatcher } from "./app state/action-dispatcher/action-dispatcher";
import { AppActions } from "./app state/actions/app-actions";
import { appReducers } from "./app state/app-module.reducers";
import { AppEffects } from "./app state/effects/app.effects";
import { appReducer } from "./app state/reducers/app.reducers";
import { AppComponent } from "./app.component";
import { AppRoutingModule, appRoutingProviders } from "./app.routes";
import { BillingModule } from './billings/billing.module';
import { SuperBillsService } from './billings/services/superbill.service';
import { CanActivateMenuGuard } from './canActivateMenuGuard.service';
import { SibGridModule } from "./components/sib-forms/grid/grid.module";
import { HoardingGroupService } from './contracts/services/hoarding-group.service';
import { SupplierVendorService } from './contracts/services/supplier-vendor.service';
import { InputTrimModule } from "./directives/input-trim/input-trim.module";
// import { PlanModule } from "./plans/plan.module";
import { EventComponent } from "./events/event.component";
import { HoardingGroupsModule } from "./hoarding-groups/hoarding-groups.module";
import { HoardingStatusService } from './hoardings-operation/services/hoardings-status.service';
import { FilterService } from "./hoardings/services/filter.service";
import { AuthGuardService } from "./login-service/auth-guard.service";
import { AuthService } from "./login-service/auth.service";
import { HttpConfigurationService } from "./masters/configurations/services/http-configuration.service";
import { UiConfigurationService } from "./masters/configurations/services/ui-configuration.service";
import { SettingService } from "./masters/setting/services/setting.service";
import { EventConfig } from "./modals/events/event-config";
import { SharedModules } from "./modules/shared.modules";
import { PlaygroundComponent } from './playground/playground.component';
import { ReportsModule } from './reports/reports.module';
import { AppConfig } from "./services/app-config.service";
import { AuthConfigService } from "./services/authconfig.service";
import { BASE_URL } from "./services/base-service/api.service";
import { AUTH_PERMISSION_URL } from "./services/base-service/auth-permission.service";
import { AUTH_API_URL } from "./services/base-service/auth.service";
import { DUMMY_URL } from "./services/base-service/dummy.service";
import { HELP_URL } from './services/base-service/help.service';
import { NotificatoinsService } from "./services/notifications/notifications.service";
import { configFactory, ServiceModule } from "./services/services.module";
import { ActivityLoogService } from "./services/shared/activity-logs.service";
// import { CampaignModule } from "./campaigns/campaign.module";
import { AreaCategoryService } from "./services/shared/area-category.service";
import { GoogleAreaChartService } from './services/shared/area-chart.service';
import { AreaService } from "./services/shared/area.service";
import { AreaListService } from "./services/shared/areaList.service";
import { AreaListGetService } from "./services/shared/areaListGet.service";
import { AreaPostService } from "./services/shared/areaPost.service";
import { ArticlesGetService } from './services/shared/articles-get.service';
import { ArticlesService } from './services/shared/articles.service';
import { AuthApiService } from "./services/shared/auth-api.service";
// import { CampaignEditDialogModule } from "./shared/components/campaign-edit-dialog/campaign-edit-dialog.module";
import { AuthUserAPIService } from "./services/shared/auth-user.service";
import { BillingConfigurationService } from "./services/shared/billing-configuration.service";
import { CampaignConfigurationService } from "./services/shared/campaign-configuration.service";
import { ChangesService } from './services/shared/changes.service';
import { ChatBaseService } from "./services/shared/chat.base.services";
import { CityService } from "./services/shared/cities.service";
import { GoogleColumnChartService } from "./services/shared/column-chart.service";
import { ContractHoardingService } from "./services/shared/contract-hoarding.service";
import { ContractTypeService } from "./services/shared/contract-type.service";
import { CreateMediaService } from './services/shared/create-media.service';
import { CustomerConfigurationService } from "./services/shared/customer-configuration.service";
import { DistrictService } from "./services/shared/district.service";
import { DistrictListGetService } from "./services/shared/districtListGet.service";
import { DistrictPostService } from "./services/shared/districtPost.service";
import { EmailConfigService } from "./services/shared/email-config.service";
import { EncrDecrService } from './services/shared/encr-decr.service';
import { FirebaseService } from "./services/shared/firebase.service";
import { GridService } from './services/shared/grid-service';
import { GridUiService } from './services/shared/grid-ui-service';
import { GroupService } from "./services/shared/group.service";
import { GoogleHistogramChartService } from "./services/shared/histogramChart.service";
import { HoardingConfigurationService } from "./services/shared/hoarding-configuration.service";
import { HoardingMasterColService } from "./services/shared/hoarding-master-column.service";
import { HoardingService } from "./services/shared/hoardings.service";
import { ImageService } from "./services/shared/image.service";
import { IndustryService } from "./services/shared/industry.service";
import { InventoryService } from './services/shared/inventory.service';
import { GoogleLineChartService } from "./services/shared/lineChart.services";
import { MessagingService } from './services/shared/messaging.service';
import { MonitoringConfigurationService } from "./services/shared/monitoring-configuration.service";
import { MounterService } from "./services/shared/mounter.service";
// import { RestrictBlockConvertPlanModule } from "./shared/components/restrict-block-convert-plan/restrict-block-convert-plan.module";
import { PhotoInterfaceAllImagesService, PhotoInterfaceService } from "./services/shared/photo-interface.service";
import { GooglePieChartService } from "./services/shared/pieChart.services";
import { PlanConfigurationService } from "./services/shared/plan-configuration.service";
import { PlayGroundService } from "./services/shared/playGround.service.";
import { PublicPageService } from "./services/shared/publicpage.service";
// import { AreaActionDispatcher } from "./masters/area/action-dispatcher/action-dispatcher";
import { StateService } from "./services/shared/states.service";
import { SystemService } from "./services/shared/system.service";
import { GoogleTableChartService } from "./services/shared/table-chart.service";
import { TaxConfigurationService } from "./services/shared/tax-configuration.service";
import { GoogleTimelineChartService } from "./services/shared/timeline-chart.service";
import { RemoveMonitoringService } from "./services/shared/update-monitoring.service";
import { UserService } from "./services/shared/user.service";
import { VendorService } from "./services/shared/vendor.service";
import { WebNotificationService } from './services/shared/web-notifications.service';
import { MASTER_CONFIG, MASTER_URL, SibMasterService } from "./services/sib-master.service";
import { GoogleStackedBarChartService } from "./services/stackedBarChart.service";
import { TitleService } from "./services/title.service";
import { TokenInterceptor } from "./services/tokeninterceptor/tokeninterceptor.service";
import { ActivityLogModule } from "./shared/components/activity-log/activity-log.module";
import { AddHoardingDialogModule } from "./shared/components/add-hoarding-dialog/add-hoarding-dialog.module";
import { AddMonitoringDialogModule } from "./shared/components/add-monitoring-dialog/add-monitoring-dialog.module";
import { AdditionalPriceDialogModule } from "./shared/components/additional-prices-dialog/additional-prices-dialog.module";
import { AreaDialogModule } from "./shared/components/area-dialog/area-dialog.module";
import { AssignToPlanDialogModule } from "./shared/components/assignToPlanDialog/assign-to-plan-dialog.module";
import { BillingNotesModule } from "./shared/components/billing-notes/billing-notes.module";
import { CampaignSummaryTemplateModule } from './shared/components/campaign-summary-template/campaign-summary-template.module';
import { CompareBillsModule } from "./shared/components/compareBills/compareBills.module";
import { ContractTypeDialogModule } from "./shared/components/contract-type-dialog/contract-type-dialog.module";
import { CustomerProfilePageModule } from "./shared/components/customer-profile-page/customer-profile-page.module";
import { CommonDataTableModule } from "./shared/components/dataTable/dataTable.module";
import { DateDeleteMessageDialogModule } from "./shared/components/date-delete-message-dialog/date-delete-message-dialog.module";
import { DocumentModule } from "./shared/components/documents/document.module";
import { GroupDialogModule } from "./shared/components/group-dialog/group-dialog.module";
import { GroupHoardingDialogModule } from "./shared/components/group-hoarding-dialog/group-hoarding-dialog.module";
import { HoardingDialogAreaService } from "./shared/components/hoarding-dialog/hoarding-area.serivce";
import { HoardingDialogModule } from "./shared/components/hoarding-dialog/hoarding-dialog.module";
import { HoardingGroupDialogModule } from "./shared/components/hoarding-group-dialog/hoarding-group-dialog.module";
import { HoardingGroupEditDialogModule } from "./shared/components/hoarding-group-edit-dialog/hoarding-group-edit-dialog.module";
import { HoardingMapViewModule } from './shared/components/hoarding-map-view/hoarding-map-view.module';
import { HoardingMapComponent } from './shared/components/hoarding-map/hoarding-map.component';
import { IndustryModule } from "./shared/components/industry-dialog/industry.module";
import { MapModule } from "./shared/components/map/map.module";
import { PassbookModule } from './shared/components/passbook/passbook.module';
import { CanActivatePassbookGuardService } from './shared/components/passbook/services/canActivatePassbookGuard.service';
import { PhotoDialogModule } from "./shared/components/photo-dialog/photo-dialog.module";
import { PlanListValidationDialogModule } from "./shared/components/plan-list-validation-dialog/plan-list-validation-dialog.module";
import { PreviewSendDialogModule } from "./shared/components/preview-send-dialogue/preview-send-dialog.module";
import { PreviewModule } from './shared/components/preview/preview.module';
import { SibBackModule } from "./shared/components/sib-back/sib-back.module";
import { SibEmailModule } from "./shared/components/sib-email/sib-email.module";
import { SibPPTPreviewModule } from "./shared/components/sib-ppt-preview/sib-ppt-preview.module";
// import { HotkeyModule, HotkeysService, HotkeyOptions } from 'angular2-hotkeys';
import { StatusQueueDialogModule } from "./shared/components/status-queue-dialog/status-queue-dialog.module";
import { TaskModule } from './shared/components/tasks/tasks.module';
import { CommonTreeTableModule } from "./shared/components/treeTable/tree-table.module";
// import { CampaignMonitoringTabModule } from "./shared/components/campaign-monitoring-tab/campaign-monitoring-tab.module";
// import { CampaignMonitoringValuesModule } from "./shared/components/campaign-monitoring-values/campaign-monitoring-values.module";
import { UploadImageDialogModule } from "./shared/components/upload-image-dialog/upload-image-dialog.module";
import { CurrencyMainPipe } from "./shared/helpers/currency.pipe/currency.main.pipe";
import { PackagesService } from './subscription-plans/services/packages.service';
import { SubscriptionPlansModule } from './subscription-plans/subscription-plans.module';
import { SuggestionModule } from './suggestion-view/suggestion.module';
import { PlanPublicPageService } from "./services/shared/plan-public-page.service";
import { UnauthorizedPageComponent } from './shared/components/unauthorized-page/unauthorized-page.component';
import { VisitTrackerService } from "./services/shared/VisitTrackerService.service";








export function HttpLoaderFactory(http: HttpClient) {
}

export const firebaseConfig = {
    apiKey: "AIzaSyA-jzJQfisHc6UrC5hlseKeH9AsszMS8Ns",
    authDomain: "showitbig-411c5.firebaseapp.com",
    databaseURL: "https://showitbig-411c5.firebaseio.com",
    projectId: "showitbig-411c5",
    storageBucket: "showitbig-411c5.appspot.com",
    messagingSenderId: "963545086691",
    appId: "1:963545086691:web:7287317668c299e9b8a3d6"
};
// firebase.initializeApp(firebaseConfig);

@NgModule({
    imports: [
        SharedModules,
        BrowserModule,
        HttpClientModule,
        AppRoutingModule,
        SibGridModule,
        IndustryModule,
        GroupDialogModule,
        HoardingDialogModule,
        ContractTypeDialogModule,
        DataListModule,
        AreaDialogModule,
        ReactiveFormsModule,
        FormsModule,
        ReactiveFormsModule,
        AutoCompleteModule,
        ButtonModule,
        DataTableModule,
        PanelModule,
        LightboxModule,
        TabMenuModule,
        OverlayPanelModule,
        CheckboxModule,
        TreeTableModule,
        GalleriaModule,
        TabViewModule,
        InputTextModule,
        InputTextareaModule,
        DropdownModule,
        CalendarModule,
        SidebarModule,
        PickListModule,
        SliderModule,
        ChartModule,
        DialogModule,
        StoreModule.forRoot({ appList: appReducer }),
        StoreDevtoolsModule.instrument({
            maxAge: 40,
        }),
        StoreModule.forRoot(appReducers),
        // declare using object not array
        EffectsModule.forRoot([AppEffects]),
        StoreDevtoolsModule.instrument({
            maxAge: 10,
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        ServiceModule,
        AngularFireModule.initializeApp(firebaseConfig),
        Ng2PicaModule,
        InputTrimModule,
        PhotoDialogModule,
        CurrencyMainPipe,
        CommonDataTableModule,
        AssignToPlanDialogModule,
        HoardingGroupsModule,
        StatusQueueDialogModule,
        HoardingGroupDialogModule,
        GroupHoardingDialogModule,
        AddHoardingDialogModule,
        CommonTreeTableModule,
        ProgressSpinnerModule,
        AddMonitoringDialogModule,
        DataScrollerModule,
        MenuModule,
        PreviewSendDialogModule,
        SibPPTPreviewModule,
        UploadImageDialogModule,
        AdditionalPriceDialogModule,
        MapModule,
        GMapModule,
        HoardingGroupEditDialogModule,
        BillingNotesModule,
        CompareBillsModule,
        SibBackModule,
        DocumentModule,
        TaskModule,
        PassbookModule,
        DateDeleteMessageDialogModule,
        PlanListValidationDialogModule,
        SibEmailModule,
        ActivityLogModule,
        CustomerProfilePageModule,
        QuillModule,
        EditorModule,
        TooltipModule,
        BillingModule,
        SuggestionModule,
        HoardingMapViewModule,
        AnalyticsModule,
        CampaignSummaryTemplateModule,
        // CaseListModule,
        PreviewModule,
        ReportsModule,
        AngularFireDatabaseModule,
        AngularFireAuthModule,
        AngularFireMessagingModule,
        SubscriptionPlansModule,
    ],
    bootstrap: [AppComponent],

    providers: [
        appRoutingProviders,
        AuthService,
        AuthGuardService,
        { provide: BASE_URL, useValue: environment.baseUrl },
        { provide: DUMMY_URL, useValue: environment.dummyUrl },
        { provide: MASTER_URL, useValue: environment.masterUrl },
        { provide: HELP_URL, useValue: environment.helpUrl },
        // { provide: CASE_URL, useValue: environment.caseUrl },
        { provide: AUTH_API_URL, useValue: localStorage.getItem('authApiUrl') },
        { provide: AUTH_PERMISSION_URL, useValue: localStorage.getItem('auth_permission_url') },
        { provide: MASTER_CONFIG, useValue: environment.masterConfigCredentials },
        { provide: AppConfig, useFactory: configFactory },
        TitleService,
        TranslateService,
        IndustryService, GroupService, ContractTypeService, VisitTrackerService,
        AppActions,
        ActionDispatcher,
        AuthConfigService,
        StateService,
        DistrictService,
        DistrictListGetService,
        CityService,
        AreaService,
        AreaListGetService,
        AreaListService,
        AreaPostService,
        DistrictPostService,
        AuthConfigService,
        HoardingService,
        ContractHoardingService,
        HoardingDialogAreaService,   // remove after testing
        AreaCategoryService,
        FirebaseService,
        FilterService,
        Ng2PicaService,
        EventConfig,
        NotificatoinsService,

        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        },
        AuthApiService,
        SettingService,
        UserService,
        PlayGroundService,
        RemoveMonitoringService,
        VendorService,
        SystemService,
        SibMasterService,
        MounterService,
        PublicPageService,
        PlanPublicPageService,
        PhotoInterfaceService,
        PhotoInterfaceAllImagesService,
        AuthUserAPIService,
        ImageService,
        ActivityLoogService,
        HoardingMasterColService,
        UiConfigurationService,
        HttpConfigurationService,
        EmailConfigService,
        GooglePieChartService,
        GoogleStackedBarChartService,
        GoogleAreaChartService,
        GoogleTimelineChartService,
        HoardingConfigurationService,
        CustomerConfigurationService,
        PlanConfigurationService,
        MonitoringConfigurationService,
        TaxConfigurationService,
        BillingConfigurationService,
        GoogleHistogramChartService,
        GoogleTableChartService,
        GoogleLineChartService,
        ChatBaseService,
        GridService,
        GridUiService,
        GoogleColumnChartService,
        ConfirmationService,
        ArticlesService,
        ArticlesGetService,
        CanActivatePassbookGuardService,
        ChangesService,
        HoardingStatusService,
        SuperBillsService,
        CampaignConfigurationService,
        HoardingGroupService,
        EncrDecrService,
        CreateMediaService,
        // CaseListService,
        NotificatoinsService,
        InventoryService,
        MessagingService,
        WebNotificationService,
        PackagesService,
        CanActivateMenuGuard,
        SupplierVendorService


    ],

    declarations: [
        EventComponent,
        PlaygroundComponent,
        HoardingMapComponent,
        UnauthorizedPageComponent,
    ],


})
export class AppModule { }
